
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0.000976562C4.47773 0.000976562 0 4.47783 0 10.0005C0 15.5232 4.47729 20.0001 10 20.0001C15.5231 20.0001 20 15.5232 20 10.0005C20 4.47783 15.5231 0.000976562 10 0.000976562ZM10 2.99096C11.8273 2.99096 13.308 4.47212 13.308 6.29853C13.308 8.12537 11.8273 9.60609 10 9.60609C8.17359 9.60609 6.69288 8.12537 6.69288 6.29853C6.69288 4.47212 8.17359 2.99096 10 2.99096ZM9.9978 17.3857C8.17535 17.3857 6.50619 16.722 5.21875 15.6234C4.90512 15.3559 4.72415 14.9636 4.72415 14.5521C4.72415 12.6997 6.22332 11.2173 8.07608 11.2173H11.9248C13.778 11.2173 15.2715 12.6997 15.2715 14.5521C15.2715 14.9641 15.0914 15.3555 14.7773 15.623C13.4903 16.722 11.8207 17.3857 9.9978 17.3857Z"}})])
          )
        }
      }
    